// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { Button, Select,Input,Menu, MenuItem, MenuItemGroup,Backtop,Submenu } from 'element-ui';
import VueResource from 'vue-resource'
 Vue.use(Button)
Vue.use(Select)
Vue.use(Input)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Submenu)
Vue.use(Backtop)
Vue.use(VueResource)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js